<template>
    <main id="machine-sheet-features" v-if="displayContent">
        <div class="wrapper">
            <div class="titled-container has-no-top-margin">
                <h2 class="title is-2">
                    {{ $t("technical_sheets") }}
                </h2>
                <sheet-block-associated-documents :documents="technicalNotices" :technicalModuleLang="true" />
            </div>
            <div class="titled-container" v-if="productDatas.abacuses.length>0 && productDatas.abacuses[unitType].length > 0">
                <h2 class="title is-2">
                    {{ $t("abacuses") }}
                </h2>
                <sheet-block-associated-abacuses :abacuses="productDatas.abacuses[unitType]" />
            </div>

            <div class="columns">
                <div class="column is-5-desktop is-6-tablet">
                  <div
                      v-for="attributesGroup in attributesGroups"
                      :key="attributesGroup.groupCode"
                      v-if="attributesGroup.attributes.length > 0"
                      class="titled-container">
                    <h2 class="title is-2 feature-group-title">
                      {{ attributesGroup.groupLabel }}
                    </h2>
                   <sheet-block-features-list :attributes="attributesGroup.attributes" :with-drawing-code="true" />
                  </div>
                </div>
                <div class="column is-5-desktop is-5-tablet" v-if="dimensionSlides.length > 0">
                    <div id="dimensions-diagrams-slider">
                        <hooper
                            ref="dimensions-slider"
                            :wheelControl="false"
                            @slide="slideChanged"
                        >
                            <slide v-for="(dimensionSlide, index) in dimensionSlides" :key="index">
                                <div class="diagram" :style="`background-image: url(${dimensionSlide});`">
                                    <a class="hidden-lightbox-link"
                                       data-mediabox="dimensions-diagrams-gallery"
                                       :href="dimensionSlide"
                                       :ref="'zoom-btn-'+index"
                                       @click="enableBlur()"
                                    >Agrandir</a>
                                </div>
                            </slide>
                        </hooper>
                        <a
                            class="zoom-btn"
                            @click="manualLightboxOpening()"
                        >
                            <span class="icon-zoom" :aria-label="$t('enlarge')"></span>
                        </a>
                        <div class="dimensions-diagrams-slider-controls">
                            <button class="icon-arrow-left control previous" :class="[brandBackgroundColor, {hidden: currentSlide === 0}]" @click.prevent="slidePrev"></button>
                            <button class="icon-arrow-right control next" :class="[brandBackgroundColor, {hidden: currentSlide === (dimensionSlides.length-1)}]" @click.prevent="slideNext"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import { mapState, mapGetters } from 'vuex'

    import { Hooper, Slide } from 'hooper';
    import '@/../node_modules/hooper/dist/hooper.css';
    import stickybits from 'stickybits'

    import sheetMixins from "@/common/mixins/sheet"

    import productService from '@/services/serli/product'

    import SheetBlockAssociatedDocuments from "@/components/SheetBlock/SheetBlockAssociatedDocuments";
    import SheetBlockAssociatedAbacuses from "@/components/SheetBlock/SheetBlockAssociatedAbacuses";
    import SheetBlockFeaturesList from "@/components/SheetBlock/SheetBlockFeaturesList";

    export default {
        name: 'MachineFeaturesView',
        mixins: [
            sheetMixins
        ],
        components: {
          SheetBlockFeaturesList,
            Hooper,
            Slide,
            SheetBlockAssociatedDocuments,
            SheetBlockAssociatedAbacuses
        },
        data(){
            return {
                displayContent: false,
                abacuses: [],
                attributesGroups: [],
                currentSlide: 0,
                dimensionSlides: null
            }
        },
        computed: {
            ...mapState({
                productDatas: state => state.sheet.productDatas,
                unitType: state => state.settings.unitType
            }),
            ...mapGetters({
                localeKebabFormat: 'settings/localeKebabFormat'
            }),
        },
        mounted(){
          console.log(this.unitType)
          console.log(this.productDatas.abacuses);
            this.startLoading();
            this.fetchAttributeGroupsAndAttributes()
            .then(() => this.fetchDimensionalDrawings())
            .finally(() => {
                this.displayContent = true;
                this.stopLoading()

                setTimeout(() => {
                    this.$nextTick(() => {
                        let slider = document.querySelector("#dimensions-diagrams-slider");
                        if(slider){
                            this.$root.wamediabox.bindAll(slider);
                            stickybits('#dimensions-diagrams-slider', {stickyBitStickyOffset: 185});
                        }
                    })
                }, 500)

            });
        },
        methods: {
            slidePrev() {
                this.$refs['dimensions-slider'].slidePrev();
            },
            slideNext() {
                this.$refs['dimensions-slider'].slideNext();
            },
            manualLightboxOpening() {
                this.$refs['zoom-btn-'+this.currentSlide][0].click()
            },

            async fetchAttributeGroupsAndAttributes() {
              this.attributesGroups=this.productDatas.orderedTechnicalGroups;
                //this.attributesGroups = await productService.show(this.productDatas.identifier, {
                //    locale: this.localeKebabFormat,
                //    unit: this.$store.state.settings.unitType
                //})
                //.then(({data}) => {
                //    if(data.data)
                //        return data.data.orderedTechnicalGroups
                //    return []
                //});
            },
            async fetchDimensionalDrawings() {
                let attributes = [
                    'dimensional_drawing_front_back',
                    'dimensional_drawing_side',
                    'dimensional_drawing_top',
                ];

                let dimensionSlides = [];
                attributes.forEach(attribute => {
                    if(this.productDatas.values[attribute] !== undefined)
                      dimensionSlides.push(this.productDatas.values[attribute].large);
                })

                this.dimensionSlides = dimensionSlides;
            },

        }
    }
</script>

<style lang="scss">
    #machine-sheet-features {
        padding-top: 35px;
        padding-bottom: 40px;

        .technical-notices-container {
            .title {
                margin-bottom: 20px;
            }
        }

        .feature-group-title {
            margin-bottom: 30px;
        }

        #dimensions-diagrams-slider {
            position: relative;
            width: 100%;
            max-width: 475px;
            margin-top: 70px;
            margin-left: 30px;
            box-shadow: 20px 20px 74px 0 rgba(0, 0, 0, 0.15);
            border-radius: 20px;
            overflow: hidden;

            @media #{$mq_phone} {
                max-width: 100%;
                margin: 0 auto;
            }

            .hooper {
                height: auto;

                .hooper-slide {
                    height: 315px;
                    padding: 20px;
                }

                .diagram {
                    position: relative;
                    height: 100%;
                    background-repeat: no-repeat;
                    background-size: contain;
                    background-position: center;

                    .hidden-lightbox-link {
                        display: none;
                    }
                }
            }

            .zoom-btn {
                position: absolute;
                bottom: 17px;
                left: 17px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 26px;
                height: 26px;
                background-color: $black;
                color: $white;
                font-size: 9px;
                border-radius: 50%;
                transition: transform 0.3s ease;

                &:hover {
                    transform: scale(1.15);
                }
            }

            .dimensions-diagrams-slider-controls {
                position: absolute;
                bottom: 17px;
                right: 17px;

                .control {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 26px;
                    height: 26px;
                    color: $white;
                    font-size: 9px;
                    border-radius: 50%;
                    cursor: pointer;
                    transition: transform 0.3s ease;

                    &:hover:not(.hidden) {
                        transform: scale(1.15);
                    }

                    &.previous {
                        margin-right: 17px;
                    }

                    &.hidden {
                        background-color: $black;
                        opacity: 0.1;
                        cursor: default;
                    }
                }
            }
        }
    }


</style>
